import React, { useState } from "react";
import { Row, Col, Button, Form, Input } from "antd";
import { useHistory } from "react-router-dom";
import resetIcon from "../../assets/images/reset-icon.png";
import AuthService from "../../services/auth.service";
import notificationService from "../../util/notification.service";
import { unAuthenticatedRoutes } from "../../routes/constant";

const FormItem = Form.Item;

const ForgetPassword = () => {
    const history = useHistory();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        const { ok } = await AuthService.forgetPassword(values);

        if (ok) {
            notificationService.info(
                `An email has been sent to ${values.email} with verification pin`
            );
            history.replace(unAuthenticatedRoutes.ENTEROTP, values.email);
        } else {
            notificationService.error("User does not exists!");
        }
        setLoading(false);
    };

    return (
        <div className=" auth-background gx-app-login-wrap forgot-pass-main">
            <div className="gx-app-login-container">
                <Row gutter={[0, 25]} type="flex">
                    <Col span={24} align="middle" justify="center">
                        <div className="gx-app-logo">
                            <img src={resetIcon} alt="" />
                            <h2>Verification</h2>
                            <p>Enter your email to receive an OTP</p>
                        </div>
                    </Col>
                    <Col span={24}>
                        <div className="gx-app-login-main-content">
                            <div className="gx-app-login-content">
                                <Form
                                    initialValues={{ remember: true }}
                                    name="basic"
                                    onFinish={onFinish}
                                    className="gx-signin-form gx-form-row0"
                                >
                                    <FormItem
                                        name="email"
                                        validateTrigger="validateTrigger"
                                        rules={[
                                            {
                                                required: true,
                                                message: "Email is Required",
                                            },
                                            {
                                                type: "email",
                                                message: "Email is not Valid",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="Your Email"
                                        ></Input>
                                    </FormItem>
                                    <FormItem justify="center">
                                        <FormItem>
                                            <Button
                                                type="primary"
                                                className="gx-mb-0 butn butn"
                                                htmlType="submit"
                                                loading={loading}
                                            >
                                                SUBMIT
                                            </Button>
                                        </FormItem>
                                    </FormItem>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
};

export default ForgetPassword;
